import { Box } from '@mui/material'
import React, { useState } from 'react'
import { fullCenter } from '../../base'
import LanguageMenu from '../Public/AppBar/LanguageMenu'
import MobileMenuIcon from './MobileMenuIcon'
import MobileDrawerMenu from './MobileDrawerMenu'
import { useMobileMenu } from './MobileMenuProvider'

export default function MobileMenu({ showLang = true, showPublicNav = true }) {
    const { setLangOpenInternal, langOpen } = useMobileMenu();

    return (
        <Box sx={{ ml: 'auto', ...fullCenter, flexDirection: 'row' }}>
            {Boolean(showLang) && <Box sx={{ mr: '8px' }}>
                <LanguageMenu setOpenExtern={setLangOpenInternal} openExtern={langOpen} />
            </Box>}
            <MobileDrawerMenu showPublicNav={showPublicNav}>
                <MobileMenuIcon />
            </MobileDrawerMenu>
        </Box>
    )
}
